// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"VerticalInputGroup_ProseMirror__3TMwK","closeBtn":"VerticalInputGroup_closeBtn__3sizr"};